﻿import { AuthGuardService } from '../services/auth-guard.service';
import { DashboardView } from '../views/dashboard/dashboard.view';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UsersComponent } from './users/users.component';
import { BlankView } from '../views/blank/blank.view';


const AdminRoutes: Routes = [
    // login view
    {
        path: 'admin', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: '', component: UsersComponent },
            { path: 'users', component: UsersComponent },

            // handle all other routes
            { path: '**', component: UsersComponent }
        ]
    },
];


@NgModule({
    imports: [RouterModule.forChild(AdminRoutes)],
    exports: [RouterModule]
})
export class AdminRoutingModule { }
